<template>
  <div id="app">
    <transition name="fadeIn" mode="out-in">
      <div class="app-content" v-if="dataReady" :key="dataReady">
        <menu-mobile v-if="getMobile"></menu-mobile>

        <header-comp></header-comp>

        <router-view></router-view>
      </div>
    </transition>

<!-- 		<div v-if="!dataReady" class="loading-page" :key="dataReady">
			<loader label="LÉO ARNAUD"></loader>
		</div> -->
	</div>
</template>

<script>
  import { common } from '~components/common'

  export default {
    name: 'app',
    components: common,
    data () {
    	this.get('menu', 'setMenuData')
      this.get('categories', 'setCategoriesData')

    	return {
        dataReady: null
      }
    },
    methods: {
      checkData () {
        if (this.getMenuData && this.getCategoriesData) {
          this.dataReady = 1
        }
      },
      updateTitle (pageTitle) {
        document.title = pageTitle
      }
    },
    watch: {
      getMenuData () {
        this.checkData()
      },
      getCategoriesData () {
        this.checkData()
      },
      getPageTitle (title) {
        this.updateTitle(title)
      }
    },
    computed: {
    	getMenuData () {
    		return this.$store.getters.getMenuData
    	},
      getCategoriesData () {
        return this.$store.getters.getCategoriesData
      },
      getMobile () {
        return this.$store.getters.getMobile
      },
      getPageTitle () {
        return this.$store.getters.getPageTitle
      }
    }
  }
</script>

<style lang="scss">
  @import '../styles/main';

  .fadeIn-enter-active,
  .fadeIn-leave-active {
    @include transition(opacity 1s);
  }

  .fadeIn-enter,
  .fadeIn-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/vue/App.vue?4e76ecb8